import React from 'react';
import Hero from '../components/Hero';
import About from '../components/About';
import Projects from '../components/Projects';
import Gallery from '../components/Gallery';
import Articles from '../components/Articles';
import Contact from '../components/Contact';
import Journey from '../components/Journey';
//import useScrollSpy from '../hooks/useScrollSpy';
import useScrollToHash from '../hooks/useScrollToHash';
import Videos from '../components/Videos';
import Demos from '../components/Demos';

function Home() {
  //useScrollSpy(['home', 'articles', 'about', 'gallery', 'projects', 'journey', 'contact']);
  useScrollToHash();

  return (
    <>
      <Hero />
      <Demos />
      <Videos />
      <Articles />
      <About />
      <Gallery />
      <Projects />
      <Journey />
      <Contact />
    </>
  );
}

export default Home;
